import React from "react";
import { useSelector } from "react-redux";

import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";

import Table from "components/Table";
import { useDictionary } from "hooks";
import { getId } from "store/actions/researchRoles";
import { researchRolesSelectors } from "store/selectors";

import { RolesTableRow } from "./RolesTableRow";
import styles from "./styles.css";

export const RolesTable = props => {
	const { actionsDisabled, isEditMode } = props;

	const dictionary = useDictionary("manageResearchTeamRoles");
	const isLoading = useSelector(researchRolesSelectors.isFetching);
	const { changed } = useSelector(researchRolesSelectors.content);

	return (
		<Table id="roles-table" className={styles.roleTable} data-edititg={isEditMode}>
			<span id="roles-table-reorder-help" className="accessibility-text">
        Activate the reorder button and use the arrow keys to reorder the list or use your mouse to
        drag/reorder. Press escape to cancel the reordering.
			</span>
			<span id="roles-table-live-region" role="log" aria-live="assertive" className="accessibility-text" />
			<Table.Header>
				<Table.Row>
					{isEditMode && <Table.HeaderCell><span className="accessibility-text">Order</span></Table.HeaderCell>}
					<Table.HeaderCell>{dictionary.tableColumns[0]}</Table.HeaderCell>
					<Table.HeaderCell><span className="accessibility-text">Additional details</span></Table.HeaderCell>
					<Table.HeaderCell style={{ width: 130 }}>{dictionary.tableColumns[1]}</Table.HeaderCell>
				</Table.Row>
			</Table.Header>
			<tbody>
				{isLoading ? (
					<Table.Row>
						<Table.Cell colSpan={3}><LoadingIndicator /></Table.Cell>
					</Table.Row>
				) : (
					changed.map((item,
						index) => {
						return (
							<RolesTableRow
								key={getId(item)}
								index={index}
								role={item}
								isEditMode={isEditMode}
								actionsDisabled={actionsDisabled}
								numberOfRoles={changed.length}
							/>
						);
					})
				)}
			</tbody>
		</Table>
	);
};
